export default __webpack_public_path__ + "static/media/t5.06a86eea.jpg";